// extracted by mini-css-extract-plugin
module.exports = {"root":"Version_root__1CmqB","suffix":"Version_suffix__2b5wX"};